import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEditorFileManagement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.073 2.11377H5.18637C4.07607 2.11377 3.01132 2.5549 2.22622 3.33999C1.44113 4.12509 1 5.18984 1 6.30014V16.7661C1 17.8763 1.44113 18.9411 2.22622 19.7262C3.01132 20.5113 4.07607 20.9525 5.18637 20.9525H17.7455C18.8558 20.9525 19.9206 20.5113 20.7057 19.7262C21.4908 18.9411 21.9319 17.8763 21.9319 16.7661V9.36658",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.97977 8.39355H1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.13867 17.7603H10.4182",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5135 3.47442L16.1759 8.80145C15.6526 9.32475 14.0827 9.57603 13.7269 9.22019C13.3711 8.86435 13.6119 7.29438 14.1456 6.77108L19.4727 1.43361C19.6101 1.29618 19.7733 1.18707 19.9529 1.11269C20.1325 1.03831 20.3249 1 20.5193 1C20.7136 1 20.9061 1.03831 21.0857 1.11269C21.2653 1.18707 21.4285 1.29618 21.5659 1.43361C21.7033 1.57105 21.8123 1.73415 21.8868 1.91373C21.9612 2.0933 21.9995 2.28583 21.9995 2.48021C21.9995 2.67458 21.9612 2.86685 21.8868 3.04642C21.8123 3.226 21.7033 3.38936 21.5659 3.5268L21.5135 3.47442Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconEditorFileManagement;
